<template>
	<div>
		<SOLoadingPage v-if="pageSetting.loading"/>

		<!--<div class="vh-100 bg-white p-d-72" v-else>-->
		<div class="vh-100 bg-white" v-else>
			<SOTitleBar
				:page-title="'Nota Top Up E-payment'"
				:type="'back'"
				@back="back"
			/>

			<div class="content-wrapper main-page showPageDefault">
				<div v-if="detail.data.detail_transaksi.status_hapus === 1">
					<div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom">
						<img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
						<div class="d-block">
							<div class="f-regular f-14 f-c-black">
								Nota ini butuh konfirmasi penghapusan
							</div>
							<div class="f-regular f-12 f-c-midgrey">
								Lakukan konfirmasi di halaman pembatalan
							</div>
						</div>
					</div>
					<div class="bg-yellow p-x-20 p-y-8 d-flex flex-column justify-content-start border-bottom">
						<SOTextEllipsis
							:line-numbers="3"
							:text-label="'Keterangan:'"
							:text-content="detail.data.detail_transaksi.keterangan_permintaan_hapus"
						/>
					</div>
					<div class="bg-yellow p-x-20 p-y-8 f-regular f-12 f-c-midgrey border-bottom">
						Lakukan konfirmasi melalui tombol di bawah.
					</div>
				</div>

				<div class="p-x-20 p-y-16">
					<div class="f-regular f-12 f-c-midgrey">
						<img src="@/assets/icon-sidebar/outlet-sidebar.svg" alt=""
						     class="m-r-4"
						     style="height: 13px; margin-top: -2px"
						/>
						{{ detail.data.detail_transaksi.nama_outlet }}
					</div>
					<div class="f-semi f-16 f-c-black m-d-4">
						{{ detail.data.detail_transaksi.idtransaksi }}
					</div>

					<div class="f-regular f-13 f-c-midgrey">
						Dibuat oleh <span class="f-c-black">{{ detail.data.detail_transaksi.nama_karyawan }}</span>
					</div>
				</div>
			</div>
			<div class="separator"></div>

			<div class="p-x-20 p-y-16">
				<SOTransaksiInfo
					:transaksi="detail.data"
				/>
			</div>
			<div class="separator"></div>

			<div class="p-x-16"
			     :class="{'p-y-20': detail.data.detail_transaksi.status_hapus !== 1, 'p-d-72 p-t-20': detail.data.detail_transaksi.status_hapus === 1}"
			     style="background: linear-gradient(180deg, rgba(242, 245, 247, 0) 0%, #F2F5F7 100%);"
			>
				<SOTransaksiDetailTagihan
					:transaksi="detail.data"
					:topup-epayment="true"
				/>
			</div>

			<div class="separator"></div>

			<div class="p-x-20 p-y-20" v-if="isRefundable && detail.data.detail_transaksi.status_hapus === 0 && validateAccess('topupEpayment.delete')">
				<SOButton
					:text="'Hapus Top Up (Refund)'"
					:outline-danger="true"
					:full="true"
					@action="() => { pageSetting.modal.refund = true }"
				/>
			</div>

			<div
				v-if="detail.data.detail_transaksi.status_hapus === 1"
				class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
				style="position: fixed; bottom: 64px"
			>
				<div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
					<SOButton
						:outline="true"
						:full="true"
						:text="'Tolak'"
						@action="tolakPenghapusan"
					/>
				</div>
				<div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
					<SOButton
						:primary="true"
						:full="true"
						:text="'Setujui'"
						@action="setujuiPenghapusan"
					/>
				</div>
			</div>

			<PaketDepositModalRefund
				v-if="pageSetting.modal.refund"
				:epayment="true"
				:idtranksaksi="detail.data.detail_transaksi.idtransaksi"
				:transaksi="detail.data"
				:refundable="detail.data.detail_transaksi.isrefundable"
				:name="detail.data.detail_transaksi.nama_konsumen"
				@close="() => { pageSetting.modal.refund = false }"
			/>
			<SOTerimaModal
				v-if="pageSetting.modal.penghapusan.setujui"
				:use-route-push="false"
				@close="() => { pageSetting.modal.penghapusan.setujui = false }"
			/>
			<SOTolakModal
				v-if="pageSetting.modal.penghapusan.tolak"
				:use-route-push="false"
				@close="() => { pageSetting.modal.penghapusan.tolak = false }"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTransaksiInfo from "@/so-components/modules/transaksi/SOTransaksiInfo";
import SOTransaksiDetailTagihan from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailTagihan";
import SOButton from "@/so-components/global/ui/SOButton";
import PaketDepositModalRefund from "./../../paket-deposit/views/modal/PaketDepositModalRefund";
import SOTolakModal from "./../../../penghapusan-transaksi/top-up-epayment/components/SOTolakModal";
import SOTerimaModal from "./../../../penghapusan-transaksi/top-up-epayment/components/SOTerimaModal";

import SOTextEllipsis from "@/so-components/global/ui/SOTextEllipsis";

export default {
	name: "TransaksiEpaymentDetailTopup",
	components: {
		SOLoadingPage,
		SOTitleBar,
		SOTransaksiInfo,
		SOTransaksiDetailTagihan,
		SOButton,
		PaketDepositModalRefund,
		SOTolakModal,
		SOTerimaModal,

		SOTextEllipsis,
	},
	computed: {
		...mapGetters("epaymentModule", {
			detail: "getDetailTopupEpayment",
		}),
		isRefundable() {
			let allowRefund = true;
			let {query: {refundable}} = this.$route;
			if (refundable !== undefined) {
				allowRefund = refundable;
			}

			return allowRefund;
		}
	},
	data() {
		return {
			idcustomer: "",
			idtransaksi: "",
			pageSetting: {
				loading: true,
				modal: {
					refund: false,
					penghapusan: {
						setujui: false,
						tolak: false,
					}
				}
			},
			exceptionPembatalanTransaksi: [3, 11],
		}
	},
	mounted() {
		this.idcustomer = this.$route.params.idcustomer
		this.idtransaksi = this.$route.params.idtransaksi

		this.getDetail()

		if (this.$route.query.modalOpen !== undefined) {
			if (this.$route.query.modalOpen === true) {
				setTimeout(() => {
					this.pageSetting.modal.refund = true
				}, 1000)
			}
		}
		this.smartTrackingView("detail_top_up_e-payment");

	},
	methods: {
		back() {
			this.$router.back()
		},
		async getDetail() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("epaymentModule/fetchDetailTopUpEpayment", this.idtransaksi)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		pembatalanTransaksi() {
			this.$router.push({
				name: "ibos",
				query: {
					part: 'transaksi/pembatalan/outlet',
					label: 'Pembatalan Transaksi Reguler'
				}
			});
		},

		setujuiPenghapusan() {
			let isException = false
			this.detail.data.rincian_pembayaran.forEach(v => {
				if (this.exceptionPembatalanTransaksi.includes(v.jenis_bayar)) {
					isException = true
				}
			})
			if (isException) {
				this.pageSetting.modal.refund = true
			} else {
				this.pageSetting.modal.penghapusan.setujui = true
			}
		},
		tolakPenghapusan() {
			this.pageSetting.modal.penghapusan.tolak = true
		}
	}
}
</script>